import moment from 'moment';
import { SCEvent } from 'shared/classes/Event';
import { AdminPerson as Person } from 'static/classes/Person';
import { BillingDetails } from 'shared/classes/Billing';
import { Host } from 'shared/classes/Host';
import { RecommendationsTemplateVM, ArtistReminderTemplateVM, HostReminderTemplateVM } from 'static/components/email-composer';
import { format_value } from 'shared/common/junkdrawer';
import { Modal } from 'bootstrap';
import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';
import { SCCombinedEvent } from 'static/classes/Event';
import { SCAdminTodo } from 'static/classes/Todo';
import { TodoViewModel } from './todosvm';

export function NewInvitesConversionViewModel(data){
    var self = this;
    self.type = "NewInvitesConversionViewModel";

    self.rootvm = data.rootvm;
    self.internal_navigate = ko.observable(true);
    self.history_pop_subscribe;

    self.history_pop = function(options){
        // This will fire on no match
        if (options.route.length === 0 && self.initialized() && !self.internal_navigate() &&
            pager.activePage$().id() == 'booking-insights') {
            // do the search here
            //console.log('history pop');
            //console.log('search query is ', self.search_query());
            self.lookup_events(false);
        }
        if(self.internal_navigate() == true){
            self.internal_navigate(false);
        }
        // scroll to the top
        $('html, body').scrollTop(0)
    }

    self.todo_vm = new TodoViewModel(data);

    self.initialized = ko.observable(false);
    self.initialize = function(){
        if (self.offset() == undefined){
            self.offset(0);
        }
        if (self.limit() == undefined){
            self.limit(10);
        }

        self.todo_vm.initialize().then(function(){
          self.filter_assigned_user(self.rootvm.user_logged_in()   );
        })

        self.history_pop_subscribe = pager.onNoMatch.add(self.history_pop);


        self.selection.subscribe(self.set_dates_based_on_selection)

        self.set_dates_based_on_selection();
        self.initialized(true);
    };

    self.afterHide = function(){
        self.history_pop_subscribe = pager.onNoMatch.remove(self.history_pop);
    }


    self.set_dates_based_on_selection = function(){
        const today = new Date();
        const startDate = new Date();
        const endDate = new Date();
        if(self.selection() == 'allconfirms' || self.selection() == 'noconfirms' || self.selection() == 'all_invites' ){
            startDate.setDate(today.getDate() - 7);
            endDate.setDate(today.getDate() + 1);

            self.start_date(startDate.toLocaleDateString('en-ca'));
            self.end_date(endDate.toLocaleDateString('en-ca'));
        }
        else if(self.selection() == 'closing_soon'){
            endDate.setDate(today.getDate() + 14);

            self.start_date(startDate.toLocaleDateString('en-ca'));
            self.end_date(endDate.toLocaleDateString('en-ca'));
        }
        else if(!self.admin_allow_date_filter()){
            self.start_date(undefined);
            self.end_date(undefined);
        }
    };


    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable(0);
    self.limit = ko.observable(10);

    self.selected_person_info = ko.observable(new Person({}));
    self.selected_event_info = ko.observable(new SCEvent({}));

    self.events = ko.observableArray([]);

    self.event_actions = ko.observableArray(['confirmed', 'waiting_for_approval', 'waiting_for_confirmation', 'no_by_host', 'no_by_artist', 'cancelled']);
    self.event_categories = ko.observableArray([ 'sofaconcert', 'wedding', 'other', 'birthday', 'family_event', 'charity', 'contest', 'special_occassion', 'corporate_event', 'external']);
    self.filter_event_action = ko.observableArray([]);
    self.filter_event_category = ko.observableArray([]);
    self.filter_min_average_fee = ko.observable(50);
    self.filter_assigned_user = ko.observable();
    self.filter_todo_type = ko.observable();
    self.filter_todos_complete = ko.observable(false);
    self.selection = ko.observable('waiting_for_approval');
    self.dateSearchType = ko.observable('event');
    self.new_options_double_no = ko.observable(false);

    self.error = ko.observable();
    self.search_query = ko.observable();

    self.search_click = function(){
        //reset offset
        self.offset(0);
        self.lookup_events();
    }

    self.admin_allow_date_filter = ko.observable(false);

    self.date_filter_disabled = ko.pureComputed(function(){
        if(self.admin_allow_date_filter()){
            return false;
        }
        if(self.selection() == 'waiting_for_approval' || self.selection() == 'waiting_for_response' || self.selection() == 'new_options' ||  self.selection() == 'waiting_for_confirmation'){
            return true;
        }
        else{
            return false;
        }
    });

    self.report_titles_and_descriptions = ko.pureComputed(function(){
        if(self.selection() == 'waiting_for_approval'){
            return {
                title:"SR1 Waiting for Approval",
                subheader: "Event groupings that are waiting for an approval. As soon as an individual invite in the grouping receives an approval, the whole grouping will continue to SR2.  Any event grouping with at least one possible date greater than today will be shown. Date range filter plays no part for this search. "
            }
        }
        else if(self.selection() == 'waiting_for_response'){
            return {
                title:"SR1.5 Waiting for response",
                subheader: "Event groupings with no approval yet where at least one invite has waited more than 48 hours with no chat reply from the artist. These artists are ghosting the host and need a nudge. Any event grouping with at least one possible date greater than today is shown. Sorted by newest invite first. Date range filter plays no part for this search."
            }
        }
        else if(self.selection() == 'new_options'){
            return {
                title:"SR2 Need new options",
                subheader: "Event groupings that have received all 'Nos'. These users need new options and then will return to report SR1. Any event grouping with at least one possible date greater than today will be shown. Date range filter plays no part for this search."
            }
        }
        else if(self.selection() == 'waiting_for_confirmation'){
            return {
                title:"SR3 Waiting for confirmation",
                subheader: "Event groupings that have received at least one approval. The ball is now in the users court as there are no barriers to booking. Any event grouping with at least one possible date greater than today will be shown. Date range filter plays no part for this search.<br /><br /><strong>Sorting</strong><br/>This report is ordered by the first approval or artist changes offer for each grouping. That is, when the estimated invite had at least one invite that entered the 'Waiting For Confirmation' state. These are ordered descending, so the newest events that have entered the report are shown at the top."
            }
        }

        else if(self.selection() == 'closing_soon'){
            return {
                title:"SR4 Closing Soon",
                subheader: "These event groupings do not yet have a confirm. They are about toe expire. In this case, the default date range is set to the next two weeks and filters all concerts with a latest possible date within the date range. They are sorted by latest possible date closest to today so that we see the events that will 'expire' next.'"
            }
        }

        else if(self.selection() == 'allconfirms'){
            return {
                title:"SR5 All Confirms",
                subheader: "All event groupings with a confirmed concert. These are our successes. The default date range is set to the last week. The date ranges filter for the confirmation date and orders by the newest confirms first."
            }
        }
        else if(self.selection() == 'noconfirms'){
            return {
                title:"SR6 No Confirms",
                subheader: "All past event groupings with out confirmed concert. These are our misses. The default date range is set to the last week. The date ranges filter for the latest possible date in the event grouping. In process, this means event groupings that have expired from SR4 and then fall into SR6."
            }
        }
        if(self.selection() == 'all_invites'){
            return {
                title:"SR7 All Invites",
                subheader: "Shows us all event groupings. Date range selector filters by the most recent individual event invite. This is similar to "
            }
        }
        else{
            return {
                title:"Not Created",
                subheader: "This is a description of the all invites report"
            }


        }
    });

    self.start_date = ko.observable();
    /*
    self.start_date.subscribe(function(newValue) {
        $('#newconFilterEnddate').datepicker('setStartDate', newValue);
    });
    */
    self.end_date = ko.observable();
    /*
    self.end_date.subscribe(function(newValue) {
        $('#newconFilterStartdate').datepicker('setEndDate', newValue);
    });
    */
    self.row_style = function(scevent){
        return '';
    };


    self.toggle_virtual_event = function(v_event){
        if(v_event.is_closed()){
            ko.utils.arrayForEach(v_event.invites(), function(invite){
                invite.admin_un_close();
            });
        }else{
            ko.utils.arrayForEach(v_event.invites(), function(invite){
                invite.admin_close();
            });
        }

        notyf.success("Closed event");
    }

    self.create_navigation_string = function(){
        var navigation_string = ("#concerts/booking-insights"
            + "?offset="
            + self.offset()
            + "&limit="
            + self.limit()
        );

        if(self.search_query()){
            navigation_string += "&search_query="
            + self.search_query()
        }

        if(self.selection()){
            navigation_string += "&selection="
            + self.selection();
        }

        if(self.dateSearchType()){
            navigation_string += "&dateSearchType="
            + self.dateSearchType();
        }

        if(self.filter_event_action()){
            ko.utils.arrayForEach(self.filter_event_action(), function(filter){
                navigation_string += "&filter_event_action[]="
                + filter;
            });
        }

        if(self.filter_event_category()){
            ko.utils.arrayForEach(self.filter_event_category(), function(filter){
                navigation_string += "&filter_event_category[]="
                + filter;
            });
        }

        if(self.start_date()){
            navigation_string += "&start_date="
            + self.start_date()
        }

        if(self.end_date()){
            navigation_string += "&end_date="
            + self.end_date()
        }

        return navigation_string;
    }

    self.lookup_events = function(set_internal_navigate){
        if (self.offset() == undefined || self.offset() == 'undefined'){
            self.offset(0);
        }
        if (self.limit() == undefined || self.limit() == 'undefined'){
            self.limit(10);
        }

        if(self.initialized() && !self.rootvm.is_busy()){
            self.rootvm.is_busy(true);
            return $.ajax({

                url: self.rootvm.web_host + '/api/admin/events-new-invites',
                type: 'GET',
                data:{
                    limit: self.limit(),
                    offset: self.offset(),
                    search: self.search_query(),
                    min_avg_fee : self.filter_min_average_fee(),
                    start_date: self.start_date(),
                    end_date: self.end_date(),
                    event_type: self.filter_event_category(),
                    date_search_type: self.dateSearchType(),
                    selection: self.selection(),
                    assigned_user: self.filter_assigned_user(),
                    todo_type: self.filter_todo_type(),
                    todos_complete: self.filter_todos_complete(),
                    double_no: self.new_options_double_no()
                },

                contentType: "application/json; charset=utf-8",

                complete: function(data){
                    self.rootvm.is_busy(false);
                },

                success: function (data) {

                    self.events(ko.utils.arrayMap( data.events || [],
                        function(x){
                            x.rootvm = self.rootvm
                            const y = new SCCombinedEvent(x);
                            if(self.selection() == 'todos'){
                                y.display_sub_rows(false);
                            }
                            return y;
                        }));

                    self.total_count(data.total_count);
                    self.filtered_count(data.filtered_count);
                    self.rootvm.is_busy(false);

                    var navigation_string = self.create_navigation_string();

                    // this navigation is coming from us, so dont search
                    // again
                    if(set_internal_navigate !== false){
                        self.internal_navigate(true);
                    }

                    //console.log('internal navigate is', self.internal_navigate());
                    pager.navigate(navigation_string);
                },

                error: function (data) {
                    self.error(data.statusText);
                    self.events.removeAll();
                    self.rootvm.is_busy(false);
                }
            });
        }
    };

    self.lookup_person_info = function(person_uuid){
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/person',
            type: 'GET',
            data:{
                person_uuid: person_uuid,
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {
                //self.selected_person_info(new Person(data.person));
                self.selected_person_info().update_person_details(data.person);
                //self.selected_person_info().display_name(data.person.display_name);

                if(data.person.billing_details){
                    self.selected_person_info().billing_details(
                        new BillingDetails(data.person.billing_details));
                }
                if(data.person.host){
                    self.selected_person_info().host(new Host(data.person.host));
                }
            },
            error: function (data) {
                self.error(data.statusText);
            }
        });
    };


    self.set_selected_data = function (scevent, tabId) {
        setDataAndShowDetailsModal(scevent, tabId);
    };

    self.event_bypass_header = ko.observable();
    self.set_event_message_filter_bypass = function(scevent){
        console.log('setting filter');
        self.event_bypass_header('Message with Contact Data');
        if (scevent !== null) {
            self.selected_event_info(scevent);
            const conEventBypassModal = document.getElementById('conEventBypassModal');
            Modal.getOrCreateInstance(conEventBypassModal).show();
        }
        self.selected_event_info().lookup_filtered_messages();
        console.log("Show filter bypass modal")
    };
    self.set_event_message_allow_contact = function(scevent){
        console.log('setting allow contact');
        self.event_bypass_header('User said no Contact Data');
        self.selected_event_info(scevent);
        const conEventBypassModal = document.getElementById('conEventBypassModal');
        Modal.getOrCreateInstance(conEventBypassModal).show();
        self.selected_event_info().lookup_allow_contact();
        console.log("Show filter bypass modal")
    };

    self.set_event_message_filter_popup = function(scevent){
        console.log('setting messages pop up shown');
        self.event_bypass_header('User was shown pop up');
        self.selected_event_info(scevent);
        const conEventPopupShownModal = document.getElementById('conEventPopupShownModal');
        Modal.getOrCreateInstance(conEventPopupShownModal).show();
        self.selected_event_info().lookup_filter_popup_shown();
        console.log("Show filter bypass modal")
    };


    // TODOS
    self.open_todo_modal = function(sc_event){
        console.log("opening todo modal");
        self.todo_vm.sc_event(sc_event);
        if(self.todo_vm.todo().todo_uuid() !== undefined){
            self.todo_vm.todo(new SCAdminTodo({due_date:self.todo_vm.todo().due_date()}));
        }
        else if(self.todo_vm.todo().assigned_to() === undefined){

            // or assign to the last person it was assigned too...
            self.todo_vm.todo().assigned_to( self.rootvm.user_logged_in());

            // and update leave due date the same
        }
        const conAdminTODO = document.getElementById('conAdminTODO');
        Modal.getOrCreateInstance(conAdminTODO).show();
    }

    self.open_todo_existing = function(sc_todo, sc_event){
        //console.log("Open todo existing", sc_event);
        self.todo_vm.todo(sc_todo);
        self.todo_vm.sc_event(sc_event);
        const conAdminTODO = document.getElementById('conAdminTODO');
        Modal.getOrCreateInstance(conAdminTODO).show();
    };



    self.clear_filters = function(){
        self.filter_event_action([]);
        self.filter_event_category([]);
        self.start_date(moment());
        self.end_date(undefined);
        self.dateSearchType('event');
        self.selection('waiting_for_approval');
        self.search_query('');
        self.filter_min_average_fee(50);
    };

    self.set_host_filter = function(sccombined){
        self.filter_event_category([]);
        self.search_query(sccombined.creator_uuid())
        self.start_date(undefined);
        self.end_date(undefined);


        self.search_click();
    }

    self.set_artist_filter = function(scevent){
        self.filter_event_action([]);
        self.filter_event_category([]);
        self.start_date(undefined);
        self.end_date(undefined);
        self.dateSearchType('event');
        self.search_query(scevent.artist_uuid())
        self.search_click();
    }


    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });

    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));

        self.lookup_events();

    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_events();
    };


    self.recommendations_email_vm = new RecommendationsTemplateVM({ rootvm: self.rootvm });
    self.artist_reminder_vm = new ArtistReminderTemplateVM({ rootvm: self.rootvm });
    self.host_reminder_vm = new HostReminderTemplateVM({ rootvm: self.rootvm });

    // Maps a person's stored language to a composer locale.
    const LANGUAGE_MAP = { german: 'de', english: 'en', french: 'fr', spanish: 'en' };

    // Resolves a person's preferred language to a composer locale ('de'|'en'|'fr').
    // Falls back to 'de' when the person, the language, or the lookup is missing.
    self.resolve_person_language = function (person_uuid) {
        if (!person_uuid) return Promise.resolve('de');
        return Promise.resolve($.ajax({
            url: self.rootvm.web_host + '/api/admin/person',
            type: 'GET',
            data: { person_uuid: person_uuid },
            contentType: 'application/json; charset=utf-8',
        })).then(
            (data) => LANGUAGE_MAP[data?.person?.language] ?? 'de',
            () => 'de'
        );
    };

    self.set_send_host_reminder = (event) => {
        const vm = self.host_reminder_vm;

        // Group the invited artists by how they reacted to the host's invite.
        const invites = event.invites?.() ?? [];
        const action = (invite) => invite.current_state?.()?.event_action?.();
        const names_where = (predicate) => [...new Set(
            invites
                .filter(predicate)
                .map((invite) => invite.artist?.()?.artist_name?.())
                .filter(Boolean)
        )];
        const replied_in_chat = (i) => i.artist_reacted_in_chat?.() === true;
        const names_no = names_where((i) => action(i) === 'no');
        const names_approve = names_where((i) => action(i) === 'approve');
        const names_counter_offer = names_where((i) => action(i) === 'artist_changes_offer');
        // Invite state splits by whether the artist has replied in the chat.
        // Any other state (confirmed, host counter-offer, ...) needs no reminder.
        const names_replied_in_chat = names_where((i) => action(i) === 'invite' && replied_in_chat(i));
        const names_not_reacted = names_where((i) => action(i) === 'invite' && !replied_in_chat(i));

        vm.display_name(self.rootvm.webapp_session().user().display_name());
        vm.person_uuid(event.creator_uuid?.() ?? '');
        vm.event_uuid(invites[0]?.event_uuid?.() ?? '');
        vm.host_name(event.name?.() ?? '');
        vm.host_phone(event.phone?.() ?? '');
        vm.artists_no(names_no);
        vm.artists_approve(names_approve);
        vm.artists_counter_offer(names_counter_offer);
        vm.artists_replied_in_chat(names_replied_in_chat);
        vm.artists_not_reacted(names_not_reacted);
        // Include a group by default when it actually has artists.
        vm.include_no(names_no.length > 0);
        vm.include_approve(names_approve.length > 0);
        vm.include_counter_offer(names_counter_offer.length > 0);
        vm.include_replied_in_chat(names_replied_in_chat.length > 0);
        vm.include_not_reacted(names_not_reacted.length > 0);
        // Mail is first contact when there's no phone to have tried.
        vm.tried_phone(!!event.phone?.());

        vm.language(undefined);
        self.resolve_person_language(event.creator_uuid?.()).then((lang) => {
            vm.language(lang);
            Modal.getOrCreateInstance(document.getElementById('modalHostReminder')).show();
        });
    };

    self.set_send_artist_reminder = (invite, event) => {
        const vm = self.artist_reminder_vm;
        const artist = invite.artist?.();

        vm.display_name(self.rootvm.webapp_session().user().display_name());
        vm.artist_uuid(artist?.artist_uuid?.() ?? '');
        vm.artist_name(artist?.artist_name?.() ?? '');
        vm.artist_phone(artist?.person?.()?.phone?.() ?? '');
        vm.event_uuid(invite.event_uuid?.() ?? event.event_uuid?.() ?? '');
        const types = event.event_types?.();
        vm.event_type(Array.isArray(types) ? (types[0] ?? 'other') : (types || 'other'));
        vm.event_date(event.possible_dates?.()?.[0]);
        vm.event_location(event.location_names?.() ?? '');

        const artist_person_uuid = artist?.person?.()?.person_uuid?.() ?? artist?.person_uuid?.();
        vm.language(undefined);
        self.resolve_person_language(artist_person_uuid).then((lang) => {
            vm.language(lang);
            Modal.getOrCreateInstance(document.getElementById('modalArtistReminder')).show();
        });
    };

    self.set_send_new_recommendations = async (invite, event) => {
        const vm = self.recommendations_email_vm;

        if (vm.all_artists().length === 0) {
            vm.lookup_all_artists();
        }

        const modal = document.getElementById('modalSendNewRecommendations');
        Modal.getOrCreateInstance(modal).show();

        if (vm.event()?.event_uuid() === invite.event_uuid()) {
            return;
        }

        vm.recommend_artists([]);
        vm.ai_prepopulate_reasoning('');
        vm.ai_prepopulate_error('');
        vm.ai_prepopulate_loading(false);
        vm.ai_extra_instructions('');
        vm.sections().forEach(s => s.value(''));

        vm.display_name(self.rootvm.webapp_session().user().display_name());
        vm.host_name(event.name());
        vm.date(event.possible_dates()?.[0]);
        vm.event(invite);
        vm.event().artist().rootvm = self.rootvm;
        vm.event().artist().lookup_rcmd_artists(
            undefined,
            undefined,
            4,
            vm.event().location_uuid(),
            vm.event().host().host_uuid()
        ).then(() => {
            vm.language(undefined);
            vm.all_artists().forEach(artist => artist.selected(false));
            vm.event().artist().recommended_artists().forEach(rcmd_artist => {
                const artist = vm.all_artists().find(a => a.artist_uuid() === rcmd_artist.artist.artist_uuid);
                if (artist) artist.selected(true);
            });
            vm.sort_all_artists();
            self.resolve_person_language(event.creator_uuid()).then((lang) => {
                vm.language(lang);
                Modal.getOrCreateInstance(document.getElementById('modalSendNewRecommendations')).show();
            });
        });
    };

    self.format_value = (value) => format_value(value);
};
